export const CLOSE_OR_OPEN_PERIOD_REQ = "CLOSE_OR_OPEN_PERIOD_REQ";
export const CLOSE_OR_OPEN_PERIOD_RES = "CLOSE_OR_OPEN_PERIOD_RES";
export const CLOSE_OR_OPEN_PERIOD_ERR = "CLOSE_OR_OPEN_PERIOD_ERR";